import React from 'react';
import Carousel from './CarouselWithContent';
import Achievements from './Achievements';
import Programs from './programs';
import Updates from './Updates';
import WhyTBIF from './whyTBIF';
import SparksWidget from './SparksWidget';
import { ArrowRight, CheckCircle2, Globe, ShieldCheck, Zap, Beaker, Rocket} from 'lucide-react';

function Landing() {
  return (
    <div className='font-sans text-slate-900 bg-slate-50 selection:bg-blue-100 selection:text-blue-900 overflow-x-hidden' id="home">
      
      {/* 1. HERO SECTION (Top) */}
      <Carousel />

      {/* 2. UPDATES BAR (Below Hero, Clear Separation) */}
      <div className="relative z-30 bg-white border-b border-slate-200 shadow-sm">
         <Updates />
      </div>

      {/* 2.5 PARTNERS STRIP (New: Adds Credibility) */}
      {/* <div className="bg-slate-50 border-b border-slate-200 py-6">
        <div className="max-w-7xl mx-auto px-6 flex flex-wrap items-center justify-center md:justify-between gap-6 opacity-70 grayscale hover:grayscale-0 transition-all duration-500">
            <span className="text-xs font-bold text-slate-400 uppercase tracking-widest">Supported By:</span> */}
            {/* You can replace these text spans with actual logo images later */}
            {/* <span className="text-sm font-bold text-slate-800 flex items-center gap-2"><Globe size={16}/> DST Govt. of India</span>
            <span className="text-sm font-bold text-slate-800">NIDHI-PRAYAS</span>
            <span className="text-sm font-bold text-slate-800">MeitY</span>
            <span className="text-sm font-bold text-slate-800">Startup Punjab</span>

        </div>
      </div> */}

      {/* 3. ACHIEVEMENTS SECTION (Clean & Distinct) */}
      <section className="py-20 px-6 max-w-7xl mx-auto">
   
        <div className="text-center mb-16">
          <span className="text-blue-600 font-semibold tracking-wider text-sm uppercase">Impact & Growth</span>
          <h2 className="mt-2 text-4xl md:text-5xl font-bold text-slate-900">
            Our <span className="text-blue-600 relative inline-block">
              Achievements
              <svg className="absolute w-full h-3 -bottom-1 left-0 text-blue-200 -z-10" viewBox="0 0 100 10" preserveAspectRatio="none">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="8" fill="none" />
              </svg>
            </span>
          </h2>
          <p className="mt-4 text-slate-600 max-w-2xl mx-auto">
            Empowering innovation and fostering entrepreneurship through our comprehensive incubation program.
          </p>
        </div>
         <Achievements />
         {/* <SparksWidget /> */}
      </section>
      <WhyTBIF/>
      {/* 5. PROGRAMS */}
      <Programs />


    </div>
  );
}

// --- SUB-COMPONENTS ---

const CheckItem = ({ text }) => (
    <div className="flex items-center text-slate-700 bg-slate-50 p-3 rounded-lg border border-slate-100 shadow-sm">
        <CheckCircle2 className="w-5 h-5 text-blue-600 mr-3 shrink-0" />
        <span className="font-medium">{text}</span>
    </div>
);

const ValueCard = ({ icon, title, desc }) => (
    <div className="bg-slate-50 p-6 rounded-2xl border border-slate-200 hover:border-blue-200 hover:bg-white hover:shadow-xl transition-all duration-300 group">
        <div className="bg-white w-14 h-14 rounded-xl flex items-center justify-center shadow-sm mb-4 group-hover:scale-110 transition-transform">
            {icon}
        </div>
        <h4 className="font-bold text-slate-900 text-lg mb-2">{title}</h4>
        <p className="text-sm text-slate-500 leading-relaxed">{desc}</p>
    </div>
);

export default Landing;